import * as types from '../constants/ActionTypes';

const initialState = {
  display: false,
  isLoadingArticle: false,
  errorArticle: false,
  article: undefined,
  relatedArticles: [],
};

let contactOptionSelected = false;

export default function (state = initialState, action) {
  switch (action.type) {
    case types.REQUEST_ARTICLE:
      contactOptionSelected = false;
      return {
        ...state,
        isLoadingArticle: true,
        errorArticle: false,
        article: undefined,
        display: true,
      };

    case types.RECEIVE_ARTICLE_RESPONSE:
      return {
        ...state,
        isLoadingArticle: false,
        errorArticle: false,
        article: action.payload,
        display: !contactOptionSelected,
      };

    case types.RECEIVE_ARTICLE_ERROR:
      return {
        ...state,
        isLoadingArticle: false,
        errorArticle: true,
        article: undefined,
        display: !contactOptionSelected,
      };
    case types.REQUEST_RELATED_ARTICLE:
      return { ...state, relatedArticles: [] };
    case types.RECEIVE_RELATED_ARTICLE_RESPONSE:
      return { ...state, relatedArticles: action.payload };
    case types.RECEIVE_RELATED_ARTICLE_ERROR:
      return { ...state, relatedArticles: [] };
    case types.RESET_RELATED_ARTICLE:
      return { ...state, relatedArticles: [] };
    case types.REQUEST_BY_EMAIL:
      contactOptionSelected = true;
      return { ...state, display: false };

    case types.SELECT_TOPIC_L1:
    case types.SELECT_TOPIC_L2:
    case types.SELECT_TOPIC_L3:
    case types.SELECT_TOPIC_RESET:
    case types.RECEIVE_EMPTY_FIELDS:
      return { ...state, display: false };
    case types.CHANGE_TOPIC:
    case types.CANCEL_EMAIL_FORM:
      contactOptionSelected = false;
      return { ...state, display: true };
    case types.CANCEL_EMAIL_FORM_NO_INTENT:
      return initialState;
    default:
      return state;
  }
}
